import { ReduxHelper } from "helpers";
import { IImportProductionPlanRequest } from "model";

export const prefix = "PRODUCTION_PLAN";
export const importProductionPlan = ReduxHelper.generateActions<
  IImportProductionPlanRequest,
  undefined
>(prefix, "IMPORT_PRODUCTION_PLAN");

export const clearReducer = ReduxHelper.generateLocalAction(
  prefix,
  "CLEAR_REDUCER"
);
